import type { Module } from 'vuex';
import type { IFieldState } from './field.types';
import { state } from './field.constants';
import { actions } from '@signing-page/fields/store/field.actions';
import { getters } from '@signing-page/fields/store/field.getters';
import { mutations } from '@signing-page/fields/store/field.mutations';
import type { IRootState } from '@signing-page/store/store';

export const fields: Module<IFieldState, IRootState> = {
  actions,
  mutations,
  namespaced: true,
  state,
  getters,
};
